package com.essntl.uikit.theme

import androidx.compose.ui.text.TextStyle

class EsTypography(
    // Heading
    val h1ExtraBold36: TextStyle = TextStyle(),
    val h2Bold32: TextStyle = TextStyle(),
    val h2Regular30: TextStyle = TextStyle(),
    val h3Bold24: TextStyle = TextStyle(),
    val h3Regular24: TextStyle = TextStyle(),
    val h4SemiBold20: TextStyle = TextStyle(),
    val h565018: TextStyle = TextStyle(),

    // Subheading
    val s1Bold16: TextStyle = TextStyle(),
    val s2SemiBold16: TextStyle = TextStyle(),

    // Body
    val p1Bold16: TextStyle = TextStyle(),
    val p1Medium16: TextStyle = TextStyle(),
    val p1Regular16: TextStyle = TextStyle(),
    val p2Medium14: TextStyle = TextStyle(),
    val p2Regular14: TextStyle = TextStyle(),

    // Caption
    val c1Medium13: TextStyle = TextStyle(),
    val c1Medium11: TextStyle = TextStyle(),
)